export const decodeDateField = (dateField: string) =>
  dateField.substring(dateField.indexOf('#') + 1);

export const decodeDateResource = (dateField: string) =>
  dateField.substring(0, dateField.indexOf('#'));

export const encodeDateField = (dateFieldResource: string, dateFieldField: string) =>
  `${dateFieldResource}#${dateFieldField}`;
